<div class="ap-steps">
    <ap-stepper-header
        [visitedState]="_mainSteps"
        [activeIndex]="_getSelectedIndex()"
        [stepProgress]="getStepProgress()"
        [uniqueId]="uniqueId"
        (navigation)="_mainSteps[$event].select()"
    >
    </ap-stepper-header>

    @if (selected) {
        <div class="ap-step__title-container">
            <div class="ap-step__header-label ap-step-label--active ap-step-label--selected">
                <div class="ap-step__header-label-text">
                    <!-- If there is a label template, use it. -->
                    @if (selected.stepLabel; as stepLabel) {
                        <div class="secondary ap-step__title" data-testid="step-title">
                            <ng-container [ngTemplateOutlet]="stepLabel.template"></ng-container>
                        </div>
                    } @else {
                        <h2 class="secondary ap-step__title" data-testid="step-title">{{ selected.label }}</h2>
                    }
                </div>
                @if (selected.optional) {
                    <div class="ap-step__header-label-optional" data-testid="step-title-optional">
                        <ap-content key="stepper.optionalStep.text"></ap-content>
                    </div>
                }
            </div>
        </div>
    }

    @for (step of _steps; track step; let i = $index; let isFirst = $first; let isLast = $last) {
        <div [attr.id]="step.isSubStep() ? null : uniqueId + step.stepNumber()" role="tabpanel">
            @if (i === selectedIndex) {
                <div
                    class="ap-step"
                    [ngClass]="{
                        visited: step.completed && selectedIndex !== i,
                        pristine: !step.completed && selectedIndex !== i,
                        lastVisible: isLast,
                        active: selectedIndex === i,
                        inactive: selectedIndex !== i
                    }"
                >
                    <div class="ap-step__body">
                        <div class="ap-step__content" data-testid="step-content" role="tabpanel" [attr.aria-label]="step.label">
                            <ng-container [ngTemplateOutlet]="step.content"></ng-container>
                            <div class="ap-step__controls">
                                <ng-container [ngTemplateOutlet]="step.apStepControls?.template"></ng-container>
                            </div>
                        </div>
                        @if (_hasStepperControls(i)) {
                            <div
                                class="ap-step__content ap-step__controls"
                                role="tabpanel"
                                [attr.aria-label]="step.label"
                                [@stepTransition]="_getAnimationDirection(i)"
                            >
                                @if (!isFirst) {
                                    <ap-button
                                        data-testid="stepper-previous-button"
                                        apStepperPrevious
                                        [ariaLabel]="
                                            'stepper.button.previous.aria' | apContent: { previous: '' + this._getSelectedIndex() }
                                        "
                                        ><ap-content key="stepper.button.previous"></ap-content
                                    ></ap-button>
                                }
                                @if (!isLast) {
                                    <ap-button
                                        data-testid="stepper-next-button"
                                        apStepperNext
                                        type="reset"
                                        [ariaLabel]="'stepper.button.next.aria' | apContent: { next: '' + (this._getSelectedIndex() + 2) }"
                                        ><ap-content key="stepper.button.next"></ap-content
                                    ></ap-button>
                                }
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    }
</div>
